<template>
  <div class="row align-center departamentoFooter" :class="colorClass">
    <div class="small-12 medium-11 large-10 columns banner_titles">
      <div class="row">
        <div class="small-12 small-centered medium-9 large-9 columns">
          <h3>{{ name }} | <a :href="faculdade.url">{{ faculdade.nome }}</a></h3>
          <h3>{{ email }}
            <span v-if="contacto.length > 0">|</span>
            {{ contacto }}</h3>
        </div>
        <div class="small-12 medium-3 large-3 columns social_departamentos">
          <a target="_blank" :href="facebook" v-if="facebook.length > 0">
            <i class="fa fa-facebook"></i>
          </a>
          <a target="_blank" :href="twitter" v-if="twitter.length > 0">
            <i class="fa fa fa-twitter"></i>
          </a>
          <a target="_blank" :href="linkedin" v-if="linkedin.length > 0">
            <i class="fa fa-linkedin"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "deepFooter",
  props: ['colorClass','name','faculdade','email','contacto',"mainColor","facebook","twitter","linkedin"],
}
</script>

<style scoped>


.banner_titles h3,
.banner_titles h3 a{
  text-align: left;
  font-family: Montserrat,serif;
  font-size: 17px;
  color: white;
  margin-bottom: 3px;
}



.banner_titles {
  padding-top: 35px;
  padding-bottom: 35px;
}

.social_departamentos {
  text-align: right;
}

.social_departamentos a i {
  background: transparent;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  border: 1.2px solid rgba(255,255,255,0.78);
  color: rgba(255,255,255,0.83);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-transition: all .5s ease-in-out;
  transition: all .5s ease-in-out;
  display: inline-flex;
  font-size: 15px;
}

.social_departamentos a:hover i {
  background: white;
  color: v-bind("mainColor");
}



.social_departamentos a {
  margin-right: 10px;
}

/*Responsive - ecrãs desktop pequenos*/
@media (max-width: 1440px) {
  .banner_titles {
    font-size: 16px;
  }

}


/*Responsive - ipad*/
@media (max-width: 1025px) {

  .banner_titles h3,
  .banner_titles h3 a{
    font-size: 16px;
    
  }

}

/*Responsive - iphone*/
@media (max-width: 767px) {

  .banner_titles h3,
  .banner_titles h3 a {
    font-size: 14px;
    text-align: center;
  }

  .social_departamentos {
    text-align: center;
    padding-top: 7px;
    padding-bottom: 7px;
  }

  .banner_titles {
     padding-top: 25px;
     padding-bottom: 25px;
  }

  .banner_titles .row {
    margin-right: 0;
    margin-left: 0;
  }

  .social_departamentos a i {
    width: 40px;
    height: 40px;
    
  }

}

</style>